/**
 * PhaseEdge component
 * Special edge connecting phase nodes in the phase layout
 */

import React, { memo } from 'react';
import { EdgeProps, BaseEdge, getBezierPath } from '@xyflow/react';
import { PhaseEdgeData } from '@/types/phaseTypes';

/**
 * PhaseEdge component
 */
const PhaseEdge = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style = {},
  markerEnd,
}: EdgeProps) => {
  const edgeData = data as unknown as PhaseEdgeData;
  
  // Default edge style - thicker and more prominent than regular edges
  const defaultStyle = {
    strokeWidth: 2,
    stroke: edgeData?.color || '#888888',
    strokeDasharray: 'none',
    opacity: 0.7,
  };
  
  // Combine default style with provided style
  const edgeStyle = {
    ...defaultStyle,
    ...style,
  };
  
  // Use a high curvature for phase edges to distinguish them
  const curvature = 0.3;
  
  return (
    <BaseEdge
      id={id}
      path={getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        curvature
      })[0]}
      style={edgeStyle}
      markerEnd={markerEnd}
    />
  );
};

export default memo(PhaseEdge);